import React, { useState, useEffect, useRef } from "react";

import ChkBox from "components/Custom/ChkBox";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";

const dataJson = require("../gridData.json");

interface defaultProps {
  childRef: any;
  editRows: any[];
}

const Part2 = (props: defaultProps) => {
  const { childRef, editRows } = props;
  const [leadershipCols, setLeadershipCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: true,
      width: "25%",
    },
  ]);

  const tmpLeadershipRows = dataJson["3"]["3.1"];
  const tmpInsurenceRows = dataJson["4"]["4.1"];
  for (let key in tmpLeadershipRows) {
    tmpLeadershipRows[key].comments = "";
    tmpLeadershipRows[key].checkBoxYes = "";
    tmpLeadershipRows[key].checkBoxNo = "";
  }
  for (let key in tmpInsurenceRows) {
    tmpInsurenceRows[key].comments = "";
    tmpInsurenceRows[key].checkBoxYes = "";
    tmpInsurenceRows[key].checkBoxNo = "";
    tmpLeadershipRows[key].value = "";
  }

  const [leadershipRows, setLeadershipRows] =
    useState<any[]>(tmpLeadershipRows);
  const [insurenceCols, setInsurenceCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ insurenceRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={insurenceRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...insurenceRows,
                  check: !insurenceRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "false",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ insurenceRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={insurenceRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...insurenceRows,
                  check: !insurenceRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "value",
      name: "Value",
      type: "text",
      editable: true,
      width: "25%",
    },
  ]);
  const [insurenceRows, setInsurenceRows] = useState<any[]>(tmpInsurenceRows);

  const grid1Ref: any = useRef();
  const grid2Ref: any = useRef();

  useEffect(() => {
    childRef.saveRecord = saveRecord;
    return () => {
      childRef.saveRecord = null;
    };
  }, []);

  const saveRecord = () => {
    const section1 = grid1Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
      };
    });
    const section2 = grid2Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
      };
    });
    const items = [...section1, ...section2];
    return { items };
  };

  return (
    <>
      <h4 className="ehsHeading1">{dataJson["3"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["3"]["heading2"]}</h5>
      {leadershipRows ? (
        <ExcelGrid
          childRef={grid1Ref}
          cols={leadershipCols}
          rows={leadershipRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
      <h4 className="ehsHeading1">{dataJson["4"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["4"]["heading2"]}</h5>
      {insurenceRows ? (
        <ExcelGrid
          childRef={grid2Ref}
          cols={insurenceCols}
          rows={insurenceRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
    </>
  );
};

export default Part2;
